import React, { useState, useEffect } from 'react';

const LightboxModal = ({ image, images, onClose, onNext, onPrev }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (image && images) {
      const index = images.findIndex(img => img.id === image.id);
      setCurrentIndex(index !== -1 ? index : 0);
    }
  }, [image, images]);

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') onClose();
    if (e.key === 'ArrowRight') onNext();
    if (e.key === 'ArrowLeft') onPrev();
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose, onNext, onPrev]);

  if (!image) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm p-4">
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 sm:top-8 sm:right-8 text-white p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
      >
        <span className="material-symbols-outlined text-2xl sm:text-3xl">close</span>
      </button>

      {/* Navigation Buttons */}
      {images && images.length > 1 && (
        <>
          <button
            onClick={onPrev}
            className="absolute left-4 sm:left-8 text-white p-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors transform hover:scale-110"
          >
            <span className="material-symbols-outlined text-2xl sm:text-3xl">chevron_left</span>
          </button>
          <button
            onClick={onNext}
            className="absolute right-4 sm:right-8 text-white p-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors transform hover:scale-110"
          >
            <span className="material-symbols-outlined text-2xl sm:text-3xl">chevron_right</span>
          </button>
        </>
      )}

      {/* Image Container */}
      <div className="max-w-7xl max-h-[90vh] mx-auto">
        <div className="relative">
          <img
            src={image.imageUrl}
            alt={image.title}
            className="max-w-full max-h-[80vh] object-contain rounded-lg"
          />
          
          {/* Image Info */}
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 rounded-b-lg">
            <h3 className="text-white text-2xl sm:text-3xl font-bold mb-2">{image.title}</h3>
            <p className="text-white/80 text-sm sm:text-base">{image.category}</p>
          </div>
        </div>
      </div>

      {/* Image Counter */}
      {images && images.length > 1 && (
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white text-sm bg-white/20 px-3 py-1 rounded-full">
          {currentIndex + 1} / {images.length}
        </div>
      )}
    </div>
  );
};

export default LightboxModal;
